import { DonateIframe } from "./DonateIframe";

export const Donate = () => {
  return (
    <div id="donate" className="text-center">
      <span className="donateAnchor" id="donateAnchor" aria-hidden="true"></span>
      <div className="container">
        <div className="section-title">
          <h2>Donate</h2>
          <p>
            The Prophet (ﷺ) said: "Whoever builds a masjid for the sake of Allah, Allah will build for him a house in Paradise."
          </p>
        </div>
        <DonateIframe />
      </div>
    </div>
  );
};
